import memoize from 'memoizee';
import { contract } from '../../contract';
import { getAtricryptoInfo } from '../common';
import getPricesForAssets from './getPricesForAssets';
import { contractAbis, balancer_ABI, balancer_address, ERC20_abi, streamer_abi, liquiditygauge_v3 } from '@/constants/abis';
import pools from '@/constants/pools';
import getPoolUsdFigure from './getPoolUsdFigure';

const getCurveRewards = memoize(async () => {

  const prices = await getPricesForAssets(['harmony', 'curve-dao-token']);
  const wonePrice = prices['matic-network'];
  const crvPrice = prices['curve-dao-token'];
  let rewardRates = []
  let woneRewardRates = []

  for (const pool of pools) {
    if (pool.additionalRewards.length) {
      let gaugeContract = new contract.web3.eth.Contract(liquiditygauge_v3, pool.addresses.gauge)
      let supply = await gaugeContract.methods.totalSupply().call()
      supply = supply / 10 ** 18
      let poolStaked = await getPoolUsdFigure(supply, pool)

      if (pool.id == 'atricrypto') {
        const atricryptoLpToken = new contract.web3.eth.Contract(ERC20_abi, contractAbis.atricrypto.token_address)
        const atricryptoLpTokenTotalSupply = await atricryptoLpToken.methods.totalSupply().call() / 1e18;
        const stakedRatio = supply / atricryptoLpTokenTotalSupply;
        const { totalContractBalancesUsd } = await getAtricryptoInfo(1);

        poolStaked = totalContractBalancesUsd * stakedRatio;
      }

      for (const reward of pool.additionalRewards) {

        let streamerContract = new contract.web3.eth.Contract(streamer_abi, reward.rewardContract)

        if (reward.name == 'WONE' && reward.rewardContract) {
          let rData = await streamerContract.methods.reward_data(reward.rewardTokenAddress).call()
          let rate = (604800 * (rData.rate / 1e18) * 365 * wonePrice / 7 / (poolStaked) * 100)
          if (rData.period_finish < (Date.now() / 1000 | 0)) {
            rate = 0
          }

          woneRewardRates.push(rate)
        }
        if (reward.name == 'CRV' && reward.rewardContract) {
          let rData = await streamerContract.methods.reward_data(reward.rewardTokenAddress).call()
          let rate = (604800 * (rData.rate / 1e18) * 365 * crvPrice / 7 / (poolStaked) * 100)
          rewardRates.push(rate)
        }
      }
    }
  }

  return {
    WONE3POOL: {
      crvRewardsForPoolId: '3pool',
      rewards: woneRewardRates[0],
      price: wonePrice,
    },
    WONETRICRYPTO: {
      crvRewardsForPoolId: 'atricrypto',
      rewards: woneRewardRates[1],
      price: wonePrice,
    },
    CRV3POOL: {
      crvRewardsForPoolId: '3pool',
      rewards: rewardRates[0],
      price: crvPrice,
    }
  };
}, {
  promise: true,
  maxAge: 10 * 60 * 0, // 10m
});

export default getCurveRewards;
